import { Injectable, inject } from '@angular/core';
import { TrackingEvent } from '../../enums/tracking-event/tracking-event.enum';
import { AbstractTrackingService } from 'shared/core/data-access/analytics-types';
import { PayloadFor } from '../../models/tracking-event-data/tracking-event-data.model';

@Injectable({
    providedIn: 'root',
})
export class TrackingService {
    #trackingService = inject(AbstractTrackingService);
    #previousUrl = '';

    get previousUrl(): string {
        return this.#previousUrl;
    }

    setPreviousUrl(url: string) {
        this.#previousUrl = url;
    }

    trackEvent<T extends TrackingEvent>(event: T, data: PayloadFor<T>) {
        this.#trackingService.trackEvent(event, data);
    }
}
